// ============================================================
// paper.js — sheet sizes for the drawing export (landscape, in PDF points)
//
// 1 pt = 1/72 in. Text sizes in the templates are fixed in points, so a
// bigger sheet gives the floor plan more room rather than bigger text.
// ============================================================

export const PAPER_SIZES = {
  letter:  { label: 'Letter (8.5 × 11 in)',      w: 792,  h: 612 },
  legal:   { label: 'Legal (8.5 × 14 in)',       w: 1008, h: 612 },
  tabloid: { label: 'Tabloid (11 × 17 in)',      w: 1224, h: 792 },
  ansiC:   { label: 'ANSI C (17 × 22 in)',       w: 1584, h: 1224 },
  archC:   { label: 'ARCH C (18 × 24 in)',       w: 1728, h: 1296 },
  ansiD:   { label: 'ANSI D (22 × 34 in)',       w: 2448, h: 1584 },
  archD:   { label: 'ARCH D (24 × 36 in)',       w: 2592, h: 1728 },
};

// jsPDF accepts a [w, h] array in its `format` option for custom sizes
export const paperFormat = (key) => {
  const p = PAPER_SIZES[key] || PAPER_SIZES.letter;
  return { w: p.w, h: p.h };
};
